// extracted by mini-css-extract-plugin
export var active = "_ao-a";
export var activeIndicator = "_ao-8";
export var animate = "_ao-9";
export var disabled = "_ao-b";
export var fullWidth = "_ao-2";
export var lg = "_ao-7";
export var md = "_ao-6";
export var redoButtonTabGroup = "_ao-0";
export var sm = "_ao-5";
export var tabButton = "_ao-3";
export var tabButtonsContainer = "_ao-1";
export var xs = "_ao-4";